export const REQUEST_ERROR = 'ERROR';
export const REQUEST_PENDING = 'PENDING';
export const REQUEST_SUCCESS = 'SUCCESS';

export const REQUEST_RENEW_ID: string = 'REQUEST_RENEW_ID';
export const REQUEST_LOGIN_ID: string = 'REQUEST_LOGIN_ID';
export const REQUEST_RECOMMENDATIONS_ID: string = 'REQUEST_RECOMMENDATIONS_ID';
export const REQUEST_CONTACT_ID: string = 'REQUEST_CONTACT_ID';

export const REQUEST_CREDIT_OPTIONS_ID: string = 'REQUEST_CREDIT_OPTIONS_ID';
export const REQUEST_CREDIT_UNREQUESTED_ID: string = 'REQUEST_CREDIT_UNREQUESTED_ID';
export const REQUEST_CREDIT_REQUEST_ID: string = 'REQUEST_CREDIT_REQUEST_ID';
export const REQUEST_CREDIT_CREATE_ID: string = 'REQUEST_CREDIT_CREATE_ID';
export const REQUEST_CREDIT_MULTIPLE_UPDATE_ID: string = 'REQUEST_CREDIT_MULTIPLE_UPDATE_ID';
export const REQUEST_CREDIT_SUBMIT_ID: string = 'REQUEST_CREDIT_SUBMIT_ID';
export const REQUEST_CREDIT_ATTACHMENTS_ID: string = 'REQUEST_CREDIT_ATTACHMENTS_ID';
export const REQUEST_CREDIT_ATTACHMENTS_UPLOAD_ID: string = 'REQUEST_CREDIT_ATTACHMENTS_UPLOAD_ID';
export const REQUEST_CREDIT_VERIFY_ID: string = 'REQUEST_CREDIT_VERIFY_ID';

export const REQUEST_CARD_OPTIONS_ID: string = 'REQUEST_CARD_OPTIONS_ID';
export const REQUEST_CARD_UNREQUESTED_ID: string = 'REQUEST_CARD_UNREQUESTED_ID';
export const REQUEST_CARD_CREATE_ID: string = 'REQUEST_CARD_CREATE_ID';
export const REQUEST_CARD_REQUEST_ID: string = 'REQUEST_CARD_REQUEST_ID';
export const REQUEST_CARD_MULTIPLE_UPDATE_ID: string = 'REQUEST_CARD_MULTIPLE_UPDATE_ID';
export const REQUEST_CARD_SUBMIT_ID: string = 'REQUEST_CARD_SUBMIT_ID';
export const REQUEST_CARD_VERIFY_ID: string = 'REQUEST_CARD_VERIFY_ID';